import { Drawer } from 'antd/lib'
import React from 'react'
import ButtonCustom from '../../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFloppyDisk, faSeedling, faVial, faXmark } from '@fortawesome/free-solid-svg-icons'
import { NavegacaoDrawer } from '../../../novoCompatibilidadeAtivo/components/gavetaCadastrar/styled'
import Tabs from '../../../../../../Components/Tabs'
import { HeaderDrawer } from '../../../../../../Components/CustomUi/headerGaveta'
import { BodyDrawer } from './styled'
import { Render } from '../../../../../../Components/CustomUi/render'
import { Dados } from './dados'
import { DoseCultura } from './doseCultura'
import { ItensPerUserLogged } from '../../../../../../services/login/permissaoUsuarioLoado'

type DoseAdicionados = {
  uid: string
  cod: null
  cod_cultura: number
  cod_tipo_medida: number
  cultura_nome: string
  dose: string
}

interface PropsAditivos {
  open: boolean
  update: number
  fecharGaveta: Function
  nome_produto: string
  setNome_produto: React.Dispatch<React.SetStateAction<string>>
  fabricante: string
  setFabricante: React.Dispatch<React.SetStateAction<string>>
  setFabricante_id: React.Dispatch<React.SetStateAction<number>>
  tipo_aditivo: string
  setTipo_aditivo: React.Dispatch<React.SetStateAction<string>>
  setTipo_aditivo_id: React.Dispatch<React.SetStateAction<number>>
  tipo_formulacao: string
  setTipo_formulacao: React.Dispatch<React.SetStateAction<string>>
  setTipo_formulacao_id: React.Dispatch<React.SetStateAction<number>>
  tab_selecionar_atual: string
  setTab_selecionar_atual: React.Dispatch<React.SetStateAction<string>>
  modo_uso: string
  setModo_uso: React.Dispatch<React.SetStateAction<string>>
  observacao: string
  setObservacao: React.Dispatch<React.SetStateAction<string>>
  cultura: string
  setCultura: React.Dispatch<React.SetStateAction<string>>
  setCultura_id: React.Dispatch<React.SetStateAction<number>>
  dose: string
  setDose: React.Dispatch<React.SetStateAction<string>>
  setDose_id: React.Dispatch<React.SetStateAction<number>>
  valor: string
  setValor: React.Dispatch<React.SetStateAction<string>>
  doses_culturas_adicionados: DoseAdicionados[]
  setDoses_culturas_adicionados: React.Dispatch<React.SetStateAction<DoseAdicionados[]>>
  fakeLoading_cultura: boolean
  carregando_salvar_aditivos: boolean
  carregando_salvar_aditivos_editar: boolean
  adicionar_dose: Function
  remover_cultura_dose: Function
  salvarAditivos: Function
  dataCulturas: any[]
  dataUnidade: any[]
  dataFormulacao: any[]
  dataFabricante: any[]
  dataTipoAditivos: any[]
}

export const FormularioAditivos: React.FC<PropsAditivos> = ({
  open,
  update,
  fecharGaveta,
  nome_produto,
  setNome_produto,
  fabricante,
  setFabricante,
  setFabricante_id,
  tipo_aditivo,
  setTipo_aditivo,
  setTipo_aditivo_id,
  tipo_formulacao,
  setTipo_formulacao,
  setTipo_formulacao_id,
  tab_selecionar_atual,
  setTab_selecionar_atual,
  modo_uso,
  setModo_uso,
  observacao,
  setObservacao,
  cultura,
  setCultura,
  setCultura_id,
  dose,
  setDose,
  setDose_id,
  valor,
  setValor,
  doses_culturas_adicionados,
  setDoses_culturas_adicionados,
  fakeLoading_cultura,
  carregando_salvar_aditivos,
  carregando_salvar_aditivos_editar,
  adicionar_dose,
  remover_cultura_dose,
  salvarAditivos,
  dataCulturas,
  dataUnidade,
  dataFabricante,
  dataFormulacao,
  dataTipoAditivos,
}) => {
  return (
    <Drawer
      width={660}
      open={open}
      onClose={() => fecharGaveta()}
      closable={false}
      bodyStyle={{ padding: 0 }}
      headerStyle={{ padding: '10px 10px' }}
      destroyOnClose
      footer={
        <div className='footer'>
          <ButtonCustom
            icon={<FontAwesomeIcon icon={faFloppyDisk} />}
            type='primary'
            onClick={salvarAditivos}
            loading={carregando_salvar_aditivos || carregando_salvar_aditivos_editar}
            disabled={carregando_salvar_aditivos || carregando_salvar_aditivos_editar}
          >
            {update <= 0 ? 'Salvar' : 'Atualizar'}
          </ButtonCustom>
        </div>
      }
      title={
        <NavegacaoDrawer>
          <ButtonCustom
            danger
            icon={<FontAwesomeIcon icon={faXmark} />}
            type='tertiary'
            onClick={fecharGaveta}
            style={{ marginLeft: -10 }}
          >
            Fechar
          </ButtonCustom>
        </NavegacaoDrawer>
      }
    >
      <div>
        <HeaderDrawer>
          <div>{update <= 0 ? 'Cadastrar aditivo' : 'Atualizar aditivo'}</div>
        </HeaderDrawer>
        <BodyDrawer>
          <Tabs
            tabs={[
              { descricao: 'Dados do aditivos', icone: faVial },
              {
                descricao: 'Dose por cultura',
                icone: faSeedling,
              },
            ]}
            selecionado={tab_selecionar_atual}
            trackWidth={310}
            onChange={setTab_selecionar_atual}
          />

          <Render condition={tab_selecionar_atual === 'Dados do aditivos'}>
            <Dados
              nome_produto={nome_produto}
              setNome_produto={setNome_produto}
              fabricante={fabricante}
              setFabricante={setFabricante}
              setFabricante_id={setFabricante_id}
              tipo_aditivo={tipo_aditivo}
              setTipo_aditivo={setTipo_aditivo}
              setTipo_aditivo_id={setTipo_aditivo_id}
              tipo_formulacao={tipo_formulacao}
              setTipo_formulacao={setTipo_formulacao}
              setTipo_formulacao_id={setTipo_formulacao_id}
              modo_uso={modo_uso}
              setModo_uso={setModo_uso}
              observacao={observacao}
              setObservacao={setObservacao}
              dataFabricante={dataFabricante}
              dataFormulacao={dataFormulacao}
              dataTipoAditivos={dataTipoAditivos}
            />
          </Render>
          <Render condition={tab_selecionar_atual === 'Dose por cultura'}>
            <DoseCultura
              dataCulturas={dataCulturas}
              cultura={cultura}
              setCultura={setCultura}
              setCulturaId={setCultura_id}
              dose={dose}
              setDose={setDose}
              setDoseId={setDose_id}
              valor={valor}
              setValor={setValor}
              doses_culturas_adicionados={doses_culturas_adicionados}
              setDoses_culturas_adicionados={setDoses_culturas_adicionados}
              dataUnidadeMedida={dataUnidade}
              adicionar_dose={adicionar_dose}
              remover_cultura_dose={remover_cultura_dose}
              fakeLoading_cultura={fakeLoading_cultura}
            />
          </Render>
        </BodyDrawer>
      </div>
    </Drawer>
  )
}
